import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { RevisionAction, RevisionType } from '../Types'
import Styles from '../BlazeCommandLine.module.scss'
import { RevisionSelection } from '../api/createRevisionRequest'
import { ChangeLengthActionSelect } from './ChangeLengthActionSelect'
import { ReviseButton } from 'components/BlazeCommandLine/components/ReviseButton'
import { AlmanacEditorState } from 'stores/EditorState'
import { Selection } from 'hooks/queries/layers/revisions/useCreateRevision'
import { Heading } from 'almanac-ui/Heading/Heading'

interface Props {
  articleId: string
  layerId: string
  selection?: RevisionSelection
  almanacEditorState?: AlmanacEditorState
  previousRevisionId?: string
}

export const ChangeLengthModal = observer(function ChangeLengthModal({
  articleId,
  layerId,
  selection,
  almanacEditorState,
  previousRevisionId,
}: Props) {
  const { closeAllModals, closeModal } = useModals()
  const [action, setAction] = useState<RevisionAction>(RevisionAction.MAKE_SHORTER)

  return (
    <Modal.Root aria-labelledby="change-length-header">
      <Modal.Header title="Change Length" id="change-length-header" />

      <Modal.Content>
        <div className={Styles.section}>
          <Heading level={4}>Desired length</Heading>
          <ChangeLengthActionSelect selectedAction={action} onChange={setAction} />
        </div>
      </Modal.Content>

      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={closeModal}>
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.buttonGroup} id="doc-generation-modal-generate">
            {almanacEditorState && selection && (
              <ReviseButton
                selection={selection as Selection}
                almanacEditorState={almanacEditorState}
                articleId={articleId}
                layerId={layerId}
                prompt={{ revision_type: RevisionType.CHANGE_LENGTH, action: action }}
                onRevise={closeAllModals}
                previousRevisionId={previousRevisionId}
              />
            )}
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
})
